var React = require('react');

function WhiteRectangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M100.172 32.097a3 3 0 0 1-3 3H2.433c-.646-.002-1.265-.264-1.721-.728A2.49 2.49 0 0 1 0 32.622V3a3 3 0 0 1 3-3h94.739c.646.002 1.265.264 1.721.728a2.49 2.49 0 0 1 .712 1.747v29.622z","fill":"#fff"}));
}

WhiteRectangle.defaultProps = {"width":"101","height":"36","fill":"none"};

module.exports = WhiteRectangle;

WhiteRectangle.default = WhiteRectangle;
